export const errors = {
  'Page not available': 'Page not available',
  'Something went wrong, please try again later.': 'Something went wrong, please try again later.',
  Home: 'Home',
};
